<template>
  <div class="video-replay-popup">
    <div class="video-replay-header">
      <img class="header-logo" src="@/assets/images/logos/default.webp" alt="Logo" />
      <h2>Video Replay</h2>
    </div>

    <div class="video-container" v-if="videoUrl">
      <video id="replay-video" controls class="replay-video" :src="videoUrl"></video>
    </div>
    <div class="video-container error" v-else>
      <p>No video URL provided</p>
    </div>

    <div class="match-info">
      <div class="info-row">
        <span class="label">Arena:</span>
        <span class="value text-uppercase">{{ arenaCode }}</span>
      </div>
      <div class="info-row">
        <span class="label">Match:</span>
        <span class="value">{{ matchCode }}</span>
      </div>
      <div class="info-row">
        <span class="label">Fight:</span>
        <span class="value">{{ fightNumber }}</span>
      </div>
      <div class="info-row">
        <span class="label">Time:</span>
        <span class="value">{{ formattedTime }}</span>
      </div>
      <div class="info-row">
        <span class="label">Result:</span>
        <span class="value text-uppercase" :class="resultClass">{{ result }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      videoUrl: null,
      shareUrl: null,
      arenaCode: '-',
      matchCode: '-',
      fightNumber: '-',
      time: null,
      result: '-',
    };
  },
  computed: {
    formattedTime() {
      if (!this.time) return '-';
      const date = new Date(this.time);
      return date.toLocaleString('en-SG', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      });
    },
    resultClass() {
      if (!this.result || this.result === '-') return '';
      const r = this.result.toLowerCase();
      if (r === 'meron' || r === 'banker') return 'result-red';
      if (r === 'wala' || r === 'player') return 'result-blue';
      if (r === 'draw') return 'result-green';
      return '';
    },
  },
  mounted() {
    this.parseQueryParams();
  },
  methods: {
    parseQueryParams() {
      const query = this.$route.query;

      // Video URL (already decoded by Vue Router)
      if (query.url) {
        this.videoUrl = query.url;
      }

      // Share URL
      if (query.share_url) {
        this.shareUrl = query.share_url;
      }

      // Arena
      if (query.arena) {
        this.arenaCode = query.arena;
      }

      // Match
      if (query.match) {
        this.matchCode = query.match;
      }

      // Fight number
      if (query.fight) {
        this.fightNumber = query.fight;
      }

      // Time
      if (query.time) {
        this.time = query.time;
      }

      // Result
      if (query.result) {
        this.result = query.result;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.video-replay-popup {
  width: 100%;
  margin: 0 auto;
  background: #1a1a2e;
  color: #fff;
  font-family: 'Inter', sans-serif;
  min-height: 100vh;
}

.text-uppercase {
  text-transform: uppercase;
}

.video-replay-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 12px 16px;
  background: #16213e;
  gap: 12px;

  .header-logo {
    height: 28px;
    width: auto;
    object-fit: contain;
  }

  h2 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
  }
}

.video-container {
  width: 100%;
  background: #000;
  position: relative;
  aspect-ratio: 16 / 9;

  &.error {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #8892b0;
    font-size: 14px;
    min-height: 200px;
  }

  .replay-video {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: contain;
  }
}

.match-info {
  padding: 16px;

  .info-row {
    display: flex;
    justify-content: space-between;
    padding: 8px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);

    &:last-child {
      border-bottom: none;
    }

    .label {
      color: #8892b0;
      font-size: 14px;
    }

    .value {
      font-weight: 600;
      font-size: 14px;

      &.result-red {
        color: #e74c3c;
      }

      &.result-blue {
        color: #3498db;
      }

      &.result-green {
        color: #2ecc71;
      }
    }
  }
}

.action-buttons {
  display: flex;
  gap: 12px;
  padding: 0 16px 16px;

  .btn {
    flex: 1;
    padding: 12px;
    border: none;
    border-radius: 6px;
    font-weight: 600;
    font-size: 12px;
    cursor: pointer;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.9;
    }
  }

  .copy-btn {
    background: #2d3748;
    color: #fff;
  }

  .share-btn {
    background: #e74c3c;
    color: #fff;
  }
}
</style>
